<template>
  <b-row class="mt-5 mb-3 calend">
    <b-col class="p-sm-3">
      <h2  style="text-align:center; " class="pb-3">Calendario</h2>

      <div style="width:200px; margin:auto; text-align:center;" id="calendario">
        <b-form-select
          v-model="selected"
          :options="options"
          size="lg"
          class="cal-select mt-3 mb-5"
          @change="filterCalendar"
        ></b-form-select>
      </div>
      <div
        style="border:1px solid #ececec; max-width:900px; margin:auto; background:#fdfbfb"
        class="p-5"
      >
        <b-row tag="article" class="m-5" v-if="loading">
          <div class="col text-center">
            <b-spinner label="Spinning"></b-spinner>
          </div>
        </b-row>
        <b-row v-else>
          <b-col cols="2" class="pr-2 mr-2 pb-3 col">
            <h3 class="h3">Fecha</h3>
          </b-col>
          <b-col class="center-cal-col"></b-col>
          <b-col cols="8" class="col-8 pl-5">
            <h3 class="h3">Evento</h3>
          </b-col>
        </b-row>
        <b-row v-for="row in filteredCalendar" v-bind:key="row.id" class>
          <b-col cols="2" class="pr-1 mr-2 pb-3 col" style="text-align:center">
            <div style="font-size:34px; font-weight:500">{{day(row.fecha)}}</div>
            <div style="text-transform:uppercase">{{month(row.fecha)}}</div>
          </b-col>
          <b-col class="center-cal-col">
            <ul>
              <li></li>
            </ul>
          </b-col>
          <b-col cols="8" class="col-8 pl-5">
            <div
              style="background:#abcd02; color:#fff; font-size:11px; width:160px; text-align:center; font-weight:500"
              class="p-1"
            >{{row.horario}}</div>
            <div
              class="pl-5 pr-1 pt-2 pb-2 mt-1 mb-3"
              style="background:#ecedeb; width:80%"
            >{{row.title.rendered}}</div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>


<style scoped>
.calend {
    background-image: url("~@/assets/images/pelota.png"), url("~@/assets/images/pelota.png");
  background-repeat: no-repeat;
  background-size:400px, 400px;
  background-position: 50px 100%, 110% 10%;
}
.cal-select {
  width: 200px;
  margin: auto;
  border: 0px solid;
  border-bottom: 1px solid black;
  border-radius: 0;
}
.center-cal-col {
  border-left: 1px solid gray;
  padding: 0px;
  width: 30px !important;
  flex-grow: 0;
}
.h3 {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.2rem;
}
ul {
  list-style: none;
  margin-left: -4px;
  font-size: 45px;
  margin-right: 4px; /* Remove default bullets */
}

ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #abcd02; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}
</style>

<script>
import config from "../../public/data/config.json"
import axios from "axios";
import moment from "moment";
export default {

  methods: {
    filterCalendar() {
      this.filteredCalendar = this.events.filter(item => {
        return item.fecha && item.fecha.substring(5, 7) === this.selected;
      });
    },
    isOdd: function(index) {
      return index < 4 || index > 7; //index % 2 == 0 ;
    },
    day(date) {
      return moment(date).format("DD");
    },
    month(date) {
      return moment(date, "DD-MM-YYYY")
        .locale("es_ve")
        .format("MMM");
    }
  },
  async mounted() {
    const d = new Date();
    this.selected = ('0' + (d.getMonth()+1)).slice(-2)
    this.loading = true;
    try {
      const results = await axios.get(
        config.URL+"/evento?filter[orderby]=fecha&order=desc"
      );

      this.events = results.data;
      this.filterCalendar();
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },

  data() {
    return {
      loading: false,
      selected: "02",
      options: [
        { value: "01", text: "Enero 2020" },
        { value: "02", text: "Febrero 2020" },
        { value: "03", text: "Marzo 2020" },
        { value: "04", text: "Abril 2020" },
        { value: "05", text: "Mayo 2020" },
        { value: "06", text: "Junio 2020" },
        { value: "07", text: "Julio 2020" },
        { value: "08", text: "Agosto 2020" },
        { value: "09", text: "Septiembre 2020" },
        { value: "10", text: "Octubre 2020" },
        { value: "11", text: "Noviembre 2020" },
        { value: "12", text: "Diciembre 2020" }
      ],
      events: [],
      filteredCalendar: null
    };
  }
};
</script>

